'use client'

import { useTenant } from '@/hooks/useTenant'

import type { DEFAULT_FEATURES } from '@/config/features/featureFlags'

export function useFeatureFlag(flag: keyof typeof DEFAULT_FEATURES, defaultValue = false): boolean {
  const tenant = useTenant()

  return tenant.features[flag] ?? defaultValue
}
